__turbopack_context__.v({
  "__group-link": "navbar-group-list-module-scss-module__D1x4hq____group-link",
  "navbar-group-list": "navbar-group-list-module-scss-module__D1x4hq__navbar-group-list",
});
